
import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const handleWatchLive = () => {
    navigate('/live');
  };

  const handleStartStream = () => {
    // 滚动到直播模块的用户直播标签
    const liveSection = document.querySelector('[data-live-section]');
    if (liveSection) {
      liveSection.scrollIntoView({ behavior: 'smooth' });
      // 延迟切换到用户直播标签
      setTimeout(() => {
        const userStreamTab = document.querySelector('[data-user-stream-tab]') as HTMLButtonElement;
        if (userStreamTab) {
          userStreamTab.click();
        }
      }, 800);
    }
  };

  return (
    <section 
      className="relative h-[60vh] md:h-[70vh] flex items-center justify-center text-white overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=modern%20sports%20stadium%20with%20vibrant%20emerald%20green%20grass%20field%20and%20professional%20white%20stadium%20structure%2C%20aerial%20view%20of%20soccer%20field%20with%20bright%20green%20turf%20and%20white%20goal%20posts%2C%20clean%20sports%20venue%20with%20natural%20green%20tones%20and%20white%20architectural%20elements%2C%20perfect%20lighting%20for%20sports%20broadcasting%20platform%20with%20green%20and%20white%20color%20harmony&width=1920&height=800&seq=hero-green-new&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="container mx-auto px-4 text-center max-w-3xl">
        <h1 className="text-xl md:text-2xl lg:text-3xl font-bold mb-3 md:mb-4">
          体验最精彩的
          <span className="text-green-400 block mt-1">体育直播</span>
        </h1>
        <p className="text-sm md:text-base lg:text-lg mb-4 md:mb-6 max-w-lg mx-auto text-gray-200 leading-relaxed">
          观看全球热门体育赛事直播，回放经典比赛，还可以开启属于你的直播间
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mb-6 md:mb-8">
          <Button size="lg" className="text-sm px-6 py-3 w-full sm:w-auto whitespace-nowrap" onClick={handleWatchLive}>
            <i className="ri-live-line mr-2"></i>
            观看直播
          </Button>
          <Button variant="outline" size="lg" className="text-sm px-6 py-3 border-white text-white hover:bg-white hover:text-gray-900 w-full sm:w-auto whitespace-nowrap" onClick={handleStartStream}>
            <i className="ri-video-add-line mr-2"></i>
            开启直播间
          </Button>
        </div>
        
        {/* 统计数据 */}
        <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-md mx-auto">
          <div className="text-center">
            <div className="text-lg md:text-xl lg:text-2xl font-bold text-green-400">1000+</div>
            <div className="text-xs md:text-sm text-gray-300">每日直播场次</div>
          </div>
          <div className="text-center">
            <div className="text-lg md:text-xl lg:text-2xl font-bold text-green-400">50万+</div>
            <div className="text-xs md:text-sm text-gray-300">活跃用户</div>
          </div>
          <div className="text-center">
            <div className="text-lg md:text-xl lg:text-2xl font-bold text-green-400">24/7</div>
            <div className="text-xs md:text-sm text-gray-300">全天候服务</div>
          </div>
        </div>
      </div>
    </section>
  );
}
